import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/prospects',
  title: 'Prospects',
  endpoint: '/app/client?status=PROSPECT',
  breadcrumbs: [{ label: '', location: '' }],
}
